import { Array, Record } from 'effect'
import { isNotNullish } from 'effect/Predicate'

export function recursiveRemoveEmptyValues(object: object): object {
  const datas: Array<[string, unknown]> = Object.entries(object)

  const res = Array.flatMapNullishOr(datas, ([key, value]): [string, unknown] | undefined => {
    if (value === undefined || value === null) {
      return undefined
    }

    if (typeof value === 'object' && isNotNullish(value)) {
      const removedEmptyObject = recursiveRemoveEmptyValues(value)

      if (Object.keys(removedEmptyObject).length > 0) {
        return [key, removedEmptyObject]
      }

      return undefined
    }

    return [key, value]
  })

  return Record.fromEntries(res)
}
